import { Company } from '../../api/api-generated';
import { stringIncludesIgnoreCaseIgnoreNullSubstring } from '../../utils/comparisons';
import { CompanyFilter } from './companyTypes';

export const filterCompany = (
  item: Omit<
    Company,
    'licenses' | 'hardware' | 'rmas' | 'users' | 'demos' | 'orders'
  >,
  filters: CompanyFilter
) => {
  return stringIncludesIgnoreCaseIgnoreNullSubstring(
    item.companyName,
    filters.companyName
  );
};
